import React from 'react';
import './style.scss';

const StatsDirection = ({ className = '', type, percentage, message = 'since previous' }) => {
	if (percentage === Infinity) return null;
	return (
		<div className={`stats-direction ${className}`}>
			{type === 'positive' ? (
				<span className="stats-direction__text stats-direction__text--positive">
					▲ {percentage}% {message}
				</span>
			) : (
				<span className="stats-direction__text stats-direction__text--negative">
					▼ {percentage}% {message}
				</span>
			)}
		</div>		
	);
};

export default StatsDirection;
